// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__y01ac","tab":"Tabs_tab__cxxsK","tabName":"Tabs_tabName__D4aOw"};